import { useMessageActionContext } from '@/app/providers';
import { CloseIcon, DownloadIcon, IconReload } from '@/assets/images';
import { AppText, CustomButton } from '@/components';
import { useMediaProgress } from '@/features/chats/sub-features/media/viewmodel/useMediaProgress';
import PropTypes from 'prop-types';
import './ChatProgressLoader.scss';
import ProgressBar from './ProgressBar';

const ChatProgressLoader = ({ message, autoDownload, fileSave, loaderSize }) => {
   const { hideProgress } = useMessageActionContext();
   const msgType = message?.msgBody?.message_type || message?.msgType;
   const hideFileSizeAndCapsule = msgType === 'file' || msgType === 'audio';
   const {
      progress,
      isProgressing,
      isRetryable,
      isDownloadable,
      totalFileSize,
      cancelProgress,
      retryUploadMedia,
      downloadMedia,
   } = useMediaProgress(message, { autoDownload, fileSave });

   const handleProgressClick = () => {
      if (isProgressing) {
         cancelProgress();
      }

      if (isRetryable) {
         retryUploadMedia();
      }

      if (isDownloadable) {
         downloadMedia();
      }
   };

   const isAudio = msgType === 'audio' || msgType === 'recording';
   if ((hideProgress && !isAudio) || (!isProgressing && !isRetryable && !isDownloadable)) return null;

   return (
      <div className="progressOverlay ct-flexCenter">
         <CustomButton
            className={`${!isProgressing && !hideFileSizeAndCapsule ? 'progress-capsule' : ''} ct-flex ct-aiCenter ct-gap8`}
            onClick={handleProgressClick}
         >
            {isProgressing && (
               <CustomButton as="div" className="fileInprogess ct-flexCenter">
                  <ProgressBar progress={progress} size={loaderSize} />
                  <i className="ct-icon">
                     <CloseIcon />
                  </i>
               </CustomButton>
            )}
            {isRetryable && (
               <CustomButton as="div" className="fileInprogess ct-flexCenter">
                  <i className="ct-icon">
                     <IconReload />
                  </i>
               </CustomButton>
            )}
            {isDownloadable && (
               <CustomButton as="div" className="fileInprogess ct-flexCenter">
                  <i className="ct-icon">
                     <DownloadIcon />
                  </i>
               </CustomButton>
            )}
            {!isProgressing && !hideFileSizeAndCapsule && <AppText>{totalFileSize}</AppText>}
         </CustomButton>
      </div>
   );
};

ChatProgressLoader.propTypes = {
   message: PropTypes.shape({
      msgId: PropTypes.string.isRequired,
      msgBody: PropTypes.object,
      msgType: PropTypes.string,
   }).isRequired,
   autoDownload: PropTypes.bool,
   fileSave: PropTypes.bool,
   loaderSize: PropTypes.string,
};

export default ChatProgressLoader;
